export default {
  mounted () {
    this._setRealVhUnit()
    window.addEventListener('resize', this._setRealVhUnit)
  },
  methods: {
    _setRealVhUnit () {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.documentElement.style.setProperty('--full-height', 'calc(var(--vh, 1vh) * 100)')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/HeightFix.js